import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { StyledItemCardProps } from './ItemCard';

const ItemCardWidths = {
  xxs: '100%',
  xs: '100%',
  sm: '253px',
  lg: '276px',
  full: '100%',
};

export const ItemCardBase = styled.article<StyledItemCardProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  border: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  border-radius: ${theme.borderRadius.default};

  ${({ size }) =>
    breakpointMap(
      size,
      (cardSize) => css`
        width: ${ItemCardWidths[cardSize]};
        > * {
          max-width: ${ItemCardWidths[cardSize]};
        }
      `
    )};
`;
